export default __webpack_public_path__ + "static/media/offer1.b2cb3174.jpg";